import axios from "../axios";

export const CLSLogin = async (email, password, keepMeLoggedIn = false) => {
	const payload = {
		email,
		password,
		keepMeLoggedIn,
	};
	try {
		const response = await axios.post("api/Auth", payload);
		return response.data;
	} catch (error) {
		if (error.response) {
			console.log("API Error:", error.response.data);
			throw new Error(error.response.data.message || "Login Failed");
		} else {
			throw new Error("Network error or server unreachable");
		}
	}
};

// export const VerifyUser = async (payload) => {
// 	try {
// 		const response = await axios.post("api/Auth/VerifyUser", payload);
// 		return response.data;
// 	} catch (error) {
// 		if (error.response) {
// 			throw new Error(error.response.data.message || "Verification failed");
// 		}
// 		throw new Error("Network error");
// 	}
// };

export const VerifyUser = async (payload, appID) => {
  try {
    const response = await axios.post(
      "api/Auth/VerifyUser",
      payload,
      {
        headers: {
          "AppID": appID, 
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Verification failed");
    }
    throw new Error("Network error");
  }
};


// export const VerifyMfaOtp = async (payload) => {
// 	const response = await axios.post("api/Auth/VerifyMfaOtp", payload);
// 	return response.data;
// };

export const VerifyMfaOtp = async (payload, appId) => {
	const response = await axios.post(
		"api/Auth/VerifyMfaOtp",
		payload,
		{
			headers: {
				AppID: appId,
			},
		}
	);
	return response.data;
};


/* ---------------- MFA REGISTER ---------------- */
// export const RegisterMfa = async (payload) => {
// 	const response = await axios.post("api/Auth/RegisterMfa", payload);
// 	return response.data;
// };

export const RegisterMfa = async (payload, appId) => {
	const response = await axios.post(
		"api/Auth/RegisterMfa",
		payload,
		{
			headers: {
				AppID: appId, 
			},
		}
	);
	return response.data;
};


//Harshada Bhavsar - (07/01/2026)
// Verify Mfa Otp For Email
export const VerifyMfaOtpForEmail = async (payload) => {
  const response = await axios.post(
    "/api/Auth/VerifyMfaOtpForEmail",
    payload
  );
  return response.data;
};

//Harshada Bhavsar - (07/01/2026)
// Reset Password After Mfa
export const ResetPasswordAfterMfa = async (payload) => {
  const response = await axios.post(
    "/api/Auth/ResetPasswordAfterMfa",
    payload
  );
  return response.data;
};
